export const RepositoryNameTooltip = () => (
  <>
    GitHub repository name including "bayer-int" organization part. Example:
    "bayer-int/my-repository.
  </>
);
